import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
declare var $;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(private datePipe: DatePipe) { }
todate:any;
  ngOnInit() {
    debugger;
    
    this.transformDate();
    // console.log(this.todate);
  }
  
  transformDate() {
    this.todate =  this.datePipe.transform(new Date(), 'yyyy-MM-dd'); //whatever format you need. 
  }



}
